import type { Locale, TranslationDictionary } from "../types";
import en from "./en";
import fr from "./fr";

export const translations: Record<Locale, TranslationDictionary> = { en, fr };
